import MarketPlaceService from '@/services/MarketPlaceService.js'

export const state = {
  products: [],
  experiences: []
}

export const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  SET_EXPERIENCES(state, experiences) {
    state.experiences = experiences
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  fetchMarketPlaceProducts({ commit, dispatch }) {
    MarketPlaceService.fetchMarketPlaceProducts()
    .then(response => {
      commit('SET_PRODUCTS', response.data)
    })
    .catch(error => {
      const notification = {
        type: 'error',
        message: 'There was a problem fetching product stock: ' + error.message
      }
      dispatch('notification/add', notification, { root: true })
    })
  },
  fetchMarketPlaceProductById({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.fetchMarketPlaceProductById(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching market place product by id: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  sendInquiry({ dispatch }, inquiryData) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.sendInquiry(inquiryData)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching product stock: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  searchProducts({ commit, dispatch }, searchBody) {
    MarketPlaceService.searchProducts(searchBody)
    .then(response => {
      commit('SET_PRODUCTS', response.data)
    })
    .catch(error => {
      const notification = {
        type: 'error',
        message: 'There was a problem searching product stock: ' + error.message
      }
      dispatch('notification/add', notification, { root: true })
    })
  },
  purchaseMarketPlaceProduct({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.purchaseMarketPlaceProduct(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem purchasing product: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchPurchasedProductIds({ dispatch }) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.fetchPurchasedProductIds()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem purchasing product: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchMarketPlaceProductsForAdmin({ dispatch }) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.fetchMarketPlaceProductsForAdmin()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching market place products for admin: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  addProductToMarketPlaceAdmin({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.addProductToMarketPlaceAdmin(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching market place products for admin: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  deleteProductFromMarketPlaceAdmin({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.deleteProductFromMarketPlaceAdmin(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching market place products for admin: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchMarketPlaceExperiences({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.fetchMarketPlaceExperiences()
      .then(response => {
        commit('SET_EXPERIENCES', response.data)
        return resolve()
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching product stock: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  addExpToCatalogue({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.addExpToCatalogue(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem purchasing product: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchPurchasedExpIds({ dispatch }) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.fetchPurchasedExpIds()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching purchased experience: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  searchExperiences({ commit, dispatch }, searchBody) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.searchExperiences(searchBody)
      .then(response => {
        commit('SET_EXPERIENCES', response.data)
        return resolve()
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching experience: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  checkCategoryExist({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      MarketPlaceService.checkCategoryExist(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem checking category existence: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
}

export const getters = {}
